<template>
  <div class="player-main" id="player-ui">
    <div id="player"></div>
    <div id="player-controls" class="player shadow row align-items-center page-container pt-2">
      <div v-if="player" class="col-12 col-lg-5 col-xl-4">
        <div class="row align-items-center justify-content-center justify-content-lg-start">
          <Seek :player="player" :playing="playing" @pushPlay="pushPlay" />
          <SpeedSelector :speed="state.speed" @speed="s => updatePlaybackSpeed(s)" />

          <!-- Volume Selector -->
          <div class="d-none d-lg-flex flex-grow-1 justify-content-between align-items-center">
            <span class="btn btn-sm btn-default" @click="player.setMute()">
              <i :class="state.mute ? 'fa-volume-off' : volumeUpIcon" class="fa fa-fw"></i>
            </span>
            <vue-slider
              :direction="isRTL ? 'rtl' : 'ltr'"
              :height="4"
              :width="60"
              :min="volumeSlider.min"
              :max="volumeSlider.max"
              tooltipDir="bottom"
              v-model="state.volume"
              class="flex-grow-1"
            ></vue-slider>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-7 d-flex flex-md-row flex-column align-items-center mt-2 my-md-0"
        :class="this.player ? 'offset-xl-1' : 'offset-lg-5 offset-xl-5'">
        <TitleDetail v-if="player" :track="track" />
        <div class="flex-grow-1 mt-2 d-flex" :class="this.player ? 'my-md-0' : 'mb-3'">
          <div class="flex-grow-1">
            <search-widget />
          </div>
          <div class="d-flex align-items-center">
            <user-dropdown />
          </div>
        </div>
      </div>
      <div v-if="player" class="col-12 d-flex align-items-center text-size-sm" style="height: 16px">
        <span class="mr-3">{{ state.playHead }}</span>
        <div class="d-inline-block flex-grow-1 position-relative">
          <vue-slider
            :direction="isRTL ? 'rtl' : 'ltr'"
            :dotSize="20"
            :height="5"
            ref="slider"
            tooltip="none"
            :formatter="playheadFormatter"
            @drag-end="dragEndEvent()"
            @drag-start="dragStart()"
            :min="seeker.min"
            :max="seeker.max"
            v-model="state.position"
            class="player-seek"
            @mousemove.native="mouseMoveHandleSlider"
            @click.native="mouseClickHandleSlider"
          >
          </vue-slider>
          <div v-if="initialized" :style="{ left: `${seekSlider.left}%` }" class="custom-tooltip vue-slider-dot-tooltip-inner vue-slider-dot-tooltip-inner-top">
            {{ seekSlider.tooltipValue }}
          </div>
        </div>

        <span class="ml-3">{{ state.length }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import vueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

import VueDraggableResizable from 'vue-draggable-resizable';
import SeachWidgetComponent from '../SearchWidget.vue';
import UserDropdownComponent from '../UserDropdown.vue';
import Seek from './Seek.vue';
import SpeedSelector from './SpeedSelector.vue';
import TitleDetail from './TitleDetail.vue';

var formatTime = function (secs) {
  var date = new Date(null);
  date.setSeconds(secs);
  return date.toISOString().substr(11, 8);
};

export default {
  components: {
    'vue-draggable-resizable': VueDraggableResizable,
    vueSlider,
    SearchWidget: SeachWidgetComponent,
    UserDropdown: UserDropdownComponent,
    Seek,
    SpeedSelector,
    TitleDetail,
  },
  i18nOptions: {
    namespaces: 'components',
    keyPrefix: 'player',
  },
  data: function () {
    return {
      updatePositionInterval: null,
      seekSlider: {
        left: 0,
        tooltipValue: 0,
      },
      player: null,
      video: {
        width: '100%',
        height: 1,
        pip: false,
        x: 0,
        y: 0,
        visible: false,
      },
      state: {
        init: false,
        mute: false,
        volume: 100,
        playHead: '00:00:00',
        length: '00:00:00',
        position: 0,
        speed: 1,
        loading: false,
      },
      volumeSlider: {
        min: 0,
        max: 100,
        tooltip: 'always',
        width: 'auto',
      },
      seeker: {
        min: 0,
        max: 1000,
      },
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
      isUserVerified: 'auth/isUserVerified',
    }),
    ...mapState({
      track: function (state) {
        return state.player.track;
      },
      playing: function (state) {
        return state.player.playing;
      },
      initialized: function (state) {
        return state.player.initialized;
      },
    }),
    volumeUpIcon: function () {
      return this.state.volume > 50 ? 'fa-volume-up' : 'fa-volume-down';
    },
    playheadFormatter: function () {
      return formatTime((this.state.position * this.player.getDuration()) / 1000);
    },
    statusIcon: function () {
      if (this.state.loading) {
        return 'fa fa-spinner fa-spin';
      }
      return this.playing ? 'fa fa-pause' : 'fa fa-play';
    },
    isVideo: function () {
      return false;
    },
    playerPosition: function () {
      this.video.width = '100%';
      this.video.height = 1;
      this.video.x = 0;
      this.video.y = 0;
      return 'relative';
    },
  },

  watch: {
    video: {
      handler: function (n, o) {
        if (this.player && this.player.getControls !== n.pip)
          if (n.height <= 1) {
            n.height = 0;
          }
        this.player.resize(n.width, n.height);
      },
      deep: true,
    },
    'state.volume': function (value) {
      this.player.setVolume(value);
    },
    playing: function (value) {
      if (!value) {
        if (this.updatePositionInterval) clearInterval(this.updatePositionInterval);
        return this.player.pause();
      }

      if (!this.isLoggedIn || !this.isUserVerified) {
        return this.player.play();
      }
      this.updatePositionInterval = setInterval(() => {
        this.updatePositionInUserHistory(parseInt(this.state.time.position));
      }, 5000);
      return this.player.play();
    },
    track: function (value, old) {
      if (!this.$store.state.api.daf && !this.player) {
        this.initPlayer();
        this.pushPlay();
        return;
      } else if (!this.player) return;
      if (value.track == old.track) {
        this.player.play();
      } else {
        this.player.load([{ file: value.track }]).play();
      }
    },
  },
  methods: {
    initPlayerClick: function () {
      if (this.initialized == false) {
        this.player.play();
        this.player.stop();
      }
    },
    pushPlay: function () {
      if (this.initialized == false) {
        this.initPlayerClick();
      }
      this.$store.dispatch('player/setStatus', !this.playing);
    },
    seekToDuration(duration) {
      let track = this.track;
      track.jumpedToDurationPlayed = true;
      this.$store.dispatch('player/setTrack', track);
      this.player.seek(duration);
    },
    dragEndEvent: function (context) {
      this.player.seek((this.state.position * this.player.getDuration()) / 1000).play();
      this.$store.dispatch('player/setStatus', true);
    },
    dragStart: function (context) {
      this.$store.dispatch('player/setStatus', false);
    },
    updatePlaybackSpeed: function (value) {
      this.state.speed = value;
      this.player.setPlaybackRate(value);
    },
    getData: function () {
      let data = this.$store.state.api.daf;
      if (!data) return;
      this.$store.dispatch('player/setTrack', {
        id: data.id,
        name: data.masechta.name + ' ' + data.daf + ' by ' + data.lecturer.name,
        image: data.lecturer.image ? data.lecturer.image.url : null,
        track: data.url_download,
        trackName: data.masechta.name + ' ' + data.daf,
        lecturerName: data.lecturer.name,
        durationPlayed: data.history ? data.history.duration_played : 0,
        jumpedToDurationPlayed: false,
      });

      this.initPlayer();
      this.player.stop();
    },
    initPlayer: function () {
      this.player = jwplayer('player')
        .setup({
          width: 0,
          height: 0,
          file: this.track.track,
          playbackRateControls: [0.75, 1, 1.25, 1.5, 1.75, 2],
        })
        .setConfig([
          {
            autoplay: false,
          },
        ])
        .on('ready', () => {
          this.player.setVolume(100);
          this.player.setPlaybackRate(1);
        })
        .on('buffer', value => {
          this.state.loading = true;
        })
        .on('meta', metadata => {
          if (metadata.duration) {
            this.state.metaDuration = metadata.duration;
            this.state.length = formatTime(metadata.duration);
          }
        })
        .on('play', value => {
          this.$store.dispatch('videoPlayer/setStatus', false);
          this.state.loading = false;
          if (this.playing == false) {
            this.player.pause();
          }

          if (this.track.durationPlayed && !this.track.jumpedToDurationPlayed && value.oldstate === 'buffering') {
            this.seekToDuration(this.track.durationPlayed);
          }

          this.video.height = 1;
        })
        .on('pause', () => {})
        .on('mute', value => {
          this.state.mute = value.mute;
        })
        .on('complete', () => {})
        .on('fullscreen', e => {
          if (e.fullscreen) {
            this.player.setControls(true);
          } else if (!e.fullscreent && !this.video.pip) {
            this.player.setControls(false);
          }
        })
        .on('time', time => {
          this.state.time = time;
          this.state.playHead = formatTime(time.position);
          this.state.position = (time.position / time.duration) * 1000;

          this.state.metaDuration = time.duration;
          this.state.length = formatTime(time.duration);
        });
    },
    updatePositionInUserHistory(position) {
      this.$http.put('/api/user-shiurim-history/update', {
        shiur_id: this.track.id,
        duration_played: position,
      });
    },

    onPlayerResizing: function (l, t, w, h) {
      this.player.resize(w, h);
      this.video.width = l == 0 ? '100%' : w;
      this.video.height = h;
    },
    closeVideoPlayer: function () {
      this.$store.dispatch('player/setStatus', false);
      this.video.visible = false;
    },
    mouseMoveHandleSlider(e) {
      const sliderVm = this.$refs.slider;
      sliderVm.setScale();
      var sliderPosition = sliderVm.getPosByEvent(e);
      var position = Math.round((sliderPosition * this.player.getDuration()) / 100);

      if (sliderPosition > 0) {
        this.seekSlider.left = sliderPosition;
        this.seekSlider.tooltipValue = formatTime(position);
      }
    },
    mouseClickHandleSlider(e) {
      // if (!e.path) return;
      var eventClass = e.target.getAttribute('class');
      if (eventClass !== 'vue-slider-dot-handle vue-slider-dot-handle-focus') {
        var position = Math.round((this.seekSlider.left * this.player.getDuration()) / 100);
        this.player.stop().seek(position).play();
      }
    },
  },

  mounted: function () {
    if (this.$store.state.api.daf !== null && Object.keys(this.$store.state.api.daf).length === 0) {
      this.$store.dispatch('api/loadTodayDAF').then(() => this.getData());
    } else {
      this.getData();
    }
  },
};
</script>
<style lang="scss">
.player-main {
  .vue-slider {
    position: relative;
  }
  .custom-tooltip {
    position: absolute;
    bottom: 0%;
    transform: translate(-50%, -15px);
    display: none;

    @media (max-width: 768px) {
      display: none !important;
    }
  }

  &:hover .custom-tooltip {
    display: block;
  }
  .handle {
    position: absolute;
    width: 0;
    height: 30px;
    bottom: -15px;
    z-index: 2;

    &::before {
      font-family: FontAwesome;
      margin-left: -15px;
      background: $dark-blue;
      color: #fff;
      font-size: 1.25rem;
      width: 25px;
      height: 25px;
      line-height: 27px;
      border-radius: 50%;
      display: block;
      text-align: center;
    }
  }
  .handle-bm {
    left: 50%;
    &::before {
      content: '\F107';
    }
  }
  .handle-br {
    right: 0;
    &::before {
      content: '\F107';
      transform: rotate(-45deg);
    }
  }

  .player {
    position: fixed;
    margin: 0;
    z-index: 1000;
    background: $white;
    min-width: 100vw;
    max-height: 160px;
    @media (max-width: 992px) {
      position: relative;
    }
    .player-seek {
      position: relative;
      top: 7px;
    }
    .btn-default {
      width: 36px;
      height: 36px;
      position: relative;
      border-radius: 50%;
      padding: 10px 0px;
    }
    .fa-play,
    .fa-volume-up,
    .fa-volume-off,
    .fa-pause {
      color: $dark-blue;
      font-size: 1.2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .play-btn-container {
      border: solid 1px $light-gray;
      .fa-play {
        margin-left: 2.5px;
      }
      .fa-pause {
        color: $secondary;
      }
    }
    .speed-dropdown {
      height: 25px;
      border-radius: 15px;

      &:focus {
        outline: none;
      }

      .btn {
        color: $text-blue;
        padding: 0 15px;
        font-weight: 900;
        font-size: 0.7rem;
        span {
          margin-right: 5px;
        }
      }
      .dropdown-toggle::after {
        color: $light-gray;
        margin-left: -5px;
        font-weight: 400;
        font-size: 1rem;
        position: absolute;
        top: 40%;
      }
      .dropdown-menu {
        &:focus {
          outline: $light-gray;
        }
      }
    }
    .vue-slider-component {
      .vue-slider-dot-handle {
        background: $dark-blue;
      }
      .vue-slider-process {
        background-color: $secondary;
      }
    }
  }
  .lecturer {
    .magid-image {
      height: 50px;
      @media (max-width: 768px) {
        height: 50px;
      }
      @media (max-width: 400px) {
        display: none;
      }
    }
    .lecturer-info {
      h5 {
        color: $dark-blue;
        font-weight: bolder;
      }
      span {
        color: $text-blue;
        font-weight: 400;
      }
    }
  }
  #close-video {
    .fa {
      cursor: pointer;
      float: right;
      background: $dark-blue;
      padding: 5px 6px;
      color: $white;
      border-radius: 50px;
      position: absolute;
      top: -13px;
      right: -10px;
      z-index: 10000;
    }
  }

  .vue-slider-process {
    background-color: $primary;
  }
}
</style>
